import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { graphql, Link } from 'gatsby'
import { Layout, Listing, Wrapper, Title, Feed, Header, PostContent } from '../components'
import Img from 'gatsby-image'

class Index extends Component {
  render() {
    const {
      data: { homepage, posts },
    } = this.props
    //console.log(posts)
    return (
      <Layout>
        <Header>
          <div className='left'>
            <h1>{homepage.data.title.text}</h1>
          </div>
          <div className='right'>
            <Link to="/archive/" activeClassName="on">Archive</Link>
          </div>
        </Header>
        <Feed>
          {posts.nodes.map((post, j) => (
            <PostContent
              image_set={post.data.image_set}
              date={post.data.date}
              title={post.data.title.text}
              key={j}
            />
          ))}
        </Feed>
      </Layout>
    )
  }
}

export default Index

Index.propTypes = {
  data: PropTypes.shape({
    homepage: PropTypes.shape({
      data: PropTypes.shape({
        title: PropTypes.shape({
          text: PropTypes.string.isRequired,
        }),
        content: PropTypes.shape({
          html: PropTypes.string.isRequired,
        }),
      }),
    }),
    posts: PropTypes.shape({
      nodes: PropTypes.array.isRequired,
    }),
  }).isRequired,
}

export const pageQuery = graphql`
  query IndexQuery {
    homepage: prismicHomepage {
      data {
        title {
          text
        }
      }
    }
    posts: allPrismicPost(sort: { fields: [data___date], order: DESC }) {
      nodes {
        data {
          title {
            text
          }
          date(formatString: "MMM D")
          image_set {
            layout
            image_1 {
              localFile {
                childImageSharp {
                  fluid(maxWidth: 1600, quality: 90) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
            image_2 {
              localFile {
                childImageSharp {
                  fluid(maxWidth: 1600, quality: 90) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
